import {
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  SelectChangeEvent,
} from '@mui/material';
import React from 'react';
import './MaterialDropdown.css';

interface Option {
  value: string | number;
  label: string;
}

interface MaterialDropdownProps {
  id?: string;
  label: string;
  value: string | number;
  options: Option[];
  onChange: (value: string) => void;
  className?: string;
  fullWidth?: boolean;
  disabled?: boolean;
  variant?: 'standard' | 'outlined' | 'filled';
  size?: 'small' | 'medium';
}

const MaterialDropdown: React.FC<MaterialDropdownProps> = ({
  id,
  label,
  value,
  options,
  onChange,
  className = '',
  fullWidth = true,
  disabled = false,
  variant = 'outlined',
  size = 'small',
}) => {
  const handleChange = (event: SelectChangeEvent) => {
    onChange(event.target.value);
  };

  return (
    <FormControl
      variant={variant}
      fullWidth={fullWidth}
      size={size}
      className={`material-dropdown ${className}`}
      disabled={disabled}
    >
      <InputLabel
        id={`${id || label.toLowerCase().replace(/\s+/g, '-')}-label`}
      >
        {label}
      </InputLabel>
      <Select
        labelId={`${id || label.toLowerCase().replace(/\s+/g, '-')}-label`}
        id={id || label.toLowerCase().replace(/\s+/g, '-')}
        value={value.toString()}
        label={label}
        onChange={handleChange}
        MenuProps={{
          PaperProps: {
            style: {
              maxHeight: 300,
            },
          },
        }}
      >
        {options.map((option) => (
          <MenuItem key={option.value} value={option.value.toString()}>
            {option.label}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default MaterialDropdown;
